import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import { InfoTwoTone, OpenInNew } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { FiInbox } from "react-icons/fi";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import { useHistory } from "react-router-dom";
import CustomTabs from "../../../common/Tabs";
import Tooltip from "../../../common/Tooltip";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import { getCurrentUserId, getOrganizationId, toastError, toastSuccess } from "../../../utils";
import { updateEstimateContract } from "../Calculator/actions";
import ShareToOperationModel from "../Calculator/Contracts/ShareToOperationModel";
import { getAllOperations, getAllTeamOperations } from "./action";
import CreateOperation from "./CreateOperation";

const initialPagination = {
  offset: 1,
  limit: 50,
  totalPages: 0,
  totalItems: 0,
  search: "",
  startDate: "",
  endDate: "",
  sortBy: "createdAt",
  sortDirection: "desc",
};

const Operations = ({ setLoader, loader }) => {
  const [hasFetchedMyOp, setHasFetchedMyOp] = useState(false);
  const [hasFetchedCommonOp, setHasFetchedCommonOp] = useState(false);
  const [hasFetchedTeamOp, setHasFetchedTeamOp] = useState(false);

  const [myOpDetails, setMyOpDetails] = useState([]);
  const [commonOpDetails, setCommonOpDetails] = useState([]);
  const [teamOpDetails, setTeamOpDetails] = useState([]);

  const [myOpFilters, setMyOpFilters] = useState(initialPagination);
  const [commonOpFilters, setCommonOpFilters] = useState(initialPagination);
  const [teamOpFilters, setTeamOpFilters] = useState(initialPagination);

  const [isLoadingMyOp, setIsLoadingMyOp] = useState(true);
  const [isLoadingCommonOp, setIsLoadingCommonOp] = useState(true);
  const [isLoadingTeamOp, setIsLoadingTeamOp] = useState(true);

  const [mainTab, setMainTab] = useState(0);
  const history = useHistory();
  const organizationId = getOrganizationId();
  const [isShareToOperationModelOpen, setIsShareToOperationModelOpen] = useState(false);
  const [selectedOperation, setSelectedOperation] = useState({});
  const currentUserId = getCurrentUserId()
  const [assignToYouModelOpen, setAssignToYouModelOpen] = useState(false);
  const [openCreateOpsModel, setOpenCreateOpsModel] = useState(false);
  const [createOpsModalMaxWidth, setCreateOpsModalMaxWidth] = useState("md");

  const activeFilters = mainTab === 0 ? myOpFilters : mainTab === 1 ? commonOpFilters : teamOpFilters;
  const activeDetails = mainTab === 0 ? myOpDetails : mainTab === 1 ? commonOpDetails : teamOpDetails;
  const activeLoading = mainTab === 0 ? isLoadingMyOp : mainTab === 1 ? isLoadingCommonOp : isLoadingTeamOp;
  const activeHasFetched = mainTab === 0 ? hasFetchedMyOp : mainTab === 1 ? hasFetchedCommonOp : hasFetchedTeamOp;
  const setActiveFilters = mainTab === 0 ? setMyOpFilters : mainTab === 1 ? setCommonOpFilters : setTeamOpFilters;
  const setActiveDetails = mainTab === 0 ? setMyOpDetails : mainTab === 1 ? setCommonOpDetails : setTeamOpDetails;
  const setActiveLoading = mainTab === 0 ? setIsLoadingMyOp : mainTab === 1 ? setIsLoadingCommonOp : setIsLoadingTeamOp;
  const setActiveHasFetched = mainTab === 0 ? setHasFetchedMyOp : mainTab === 1 ? setHasFetchedCommonOp : setHasFetchedTeamOp;

  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
  };

  const fetchMyOperations = async (filtersToUse) => {
    try {
      setIsLoadingMyOp(true);
      setIsLoadingMyOp(true);
      const { offset, limit, search, startDate, endDate, sortBy, sortDirection } = filtersToUse || myOpFilters;
      const estimateRes = await getAllOperations(
        { organizationId },
        { page: offset, limit, access: "private", ...(search && { search }), ...(startDate && { startDate }), ...(endDate && { endDate }), ...(sortBy && { sortBy }), ...(sortDirection && { sortDirection }) }
      );
      setMyOpDetails(estimateRes.data || []);
      if (estimateRes) {
        setMyOpFilters((prev) => ({ ...prev, totalItems: estimateRes.totalItems || 0, totalPages: estimateRes.totalPages || 0 }));
      }
    } catch (err) {
      console.error(err);
      setMyOpDetails([]);
    } finally {
      setIsLoadingMyOp(false);
      setHasFetchedMyOp(true);
    }
  };

  const fetchCommonOperations = async (filtersToUse) => {
    try {
      setIsLoadingCommonOp(true);
      setIsLoadingCommonOp(true);
      const { offset, limit, search, startDate, endDate, sortBy, sortDirection } = filtersToUse || commonOpFilters;
      const estimateRes = await getAllOperations(
        { organizationId },
        { page: offset, limit, access: "public", ...(search && { search }), ...(startDate && { startDate }), ...(endDate && { endDate }), ...(sortBy && { sortBy }), ...(sortDirection && { sortDirection }) }
      );
      setCommonOpDetails(estimateRes.data || []);
      if (estimateRes) {
        setCommonOpFilters((prev) => ({ ...prev, totalItems: estimateRes.totalItems || 0, totalPages: estimateRes.totalPages || 0 }));
      }
    } catch (err) {
      console.error(err);
      setCommonOpDetails([]);
    } finally {
      setIsLoadingCommonOp(false);
      setHasFetchedCommonOp(true);
    }
  };

  const fetchTeamOperations = async (filtersToUse) => {
    try {
      setIsLoadingTeamOp(true);
      setIsLoadingTeamOp(true);
      const { offset, limit, search, startDate, endDate, sortBy, sortDirection } = filtersToUse || teamOpFilters;
      const estimateRes = await getAllTeamOperations(
        { organizationId },
        { page: offset, limit, ...(search && { search }), ...(startDate && { startDate }), ...(endDate && { endDate }), ...(sortBy && { sortBy }), ...(sortDirection && { sortDirection }) }
      );
      setTeamOpDetails(estimateRes.data || []);
      if (estimateRes) {
        setTeamOpFilters((prev) => ({ ...prev, totalItems: estimateRes.totalItems || 0, totalPages: estimateRes.totalPages || 0 }));
      }
    } catch (err) {
      console.error(err);
      setTeamOpDetails([]);
    } finally {
      setIsLoadingTeamOp(false);
      setHasFetchedTeamOp(true);
    }
  };

  const fetchOperations = () => {
    if (mainTab === 0) fetchMyOperations(myOpFilters);
    else if (mainTab === 1) fetchCommonOperations(commonOpFilters);
    else fetchTeamOperations(teamOpFilters);
  };

  useEffect(() => {
    const fetchInit = async () => {
      setLoader(true);
      await Promise.all([
        fetchMyOperations(myOpFilters),
        fetchCommonOperations(commonOpFilters),
        fetchTeamOperations(teamOpFilters)
      ]);
      setLoader(false);
    };
    fetchInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mainTab === 0) fetchMyOperations(myOpFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myOpFilters.offset, myOpFilters.sortBy, myOpFilters.sortDirection]);

  useEffect(() => {
    if (mainTab === 1) fetchCommonOperations(commonOpFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonOpFilters.offset, commonOpFilters.sortBy, commonOpFilters.sortDirection]);

  useEffect(() => {
    if (mainTab === 2) fetchTeamOperations(teamOpFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamOpFilters.offset, teamOpFilters.sortBy, teamOpFilters.sortDirection]);

  const handleSortClick = (sortKey) => {
    let newSortDirection = "asc";
    if (activeFilters.sortBy === sortKey) {
      if (activeFilters.sortDirection === "asc") newSortDirection = "desc";
      else if (activeFilters.sortDirection === "desc") {
        newSortDirection = sortKey === "createdAt" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdAt" ? "desc" : "asc";
    }

    let apiFilters = { ...activeFilters, sortBy: sortKey, sortDirection: newSortDirection, offset: 1 };
    if (!newSortDirection) {
      apiFilters.sortBy = "createdAt";
      apiFilters.sortDirection = "desc";
    }

    setActiveFilters(apiFilters);
  };

  const handleViewSavedOperation = async (id, type) => {
    if (type === 'actual') {
      window.open(`/saved-actual-contracts/${id}`, "_blank");
    } else {
      window.open(`/saved-operation/${id}`, "_blank");
    }
  }

  const onConfirmAssignToYou = async () => {
    try {
      const payload = {
        assignedTo: currentUserId,
        operationAccess: 'private',
      }
      await updateEstimateContract({ _id: selectedOperation }, payload)
      setMainTab(0);
      setAssignToYouModelOpen(false);
      setSelectedOperation(null);
      fetchOperations();
      toastSuccess('Operation Assigned to you successfully!');
    } catch (error) {
      toastError('Error while Assigning operation!');
      console.error('Error while Assigning operation:', error);
    }
  }
  const handleViewOperationCalc = (id, contractType) => {
    if (mainTab === 2) {
      window.open(`/ops-calc/${id}`, "_blank");
    } else {
      if (contractType === 'cargo-cargo') {
        window.open(`/cargo-cargo-calc/${id}`, "_blank");
      } else if (contractType === 'vessel-vessel') {
        window.open(`/vessel-vessel-calc/${id}`, "_blank");
      } else {
        window.open(`/operation-calc/${id}`, "_blank");
      }
    }
  }
  const handleTeamViewChange = async (id, event) => {
    const payload = {
      isTeamView: event.target.checked,
    }
    setActiveDetails((prev) =>
      prev.map(item => {
        if (item._id === id) {
          return {
            ...item,
            isTeamView: event.target.checked,
          };
        }
        return item;
      })
    );
    await updateEstimateContract({ _id: id }, payload)
    toastSuccess('Team view updated successfully!');
  };

  const onChangePagination = (type, key) => {
    setActiveFilters((prev) => {
      const currentPage = prev.offset || 1;

      let newOffset = currentPage;

      if (type === "first") {
        newOffset = 1;
      } else if (type === "dec" && currentPage > 1) {
        newOffset = currentPage - 1;
      } else if (type === "inc" && currentPage < prev.totalPages) {
        newOffset = currentPage + 1;
      } else if (type === "last") {
        newOffset = prev.totalPages;
      }

      return {
        ...prev,
        offset: newOffset,
      };
    });
  };

  useEffect(() => {
    if (!organizationId && mainTab === 2) {
      setMainTab(0);
    }
  }, [organizationId, mainTab]);

  const mainTabs = [
    { label: "My Operations", key: 0, tooltip: "Displays operations that assigned to you." },
    { label: "Common Operations", key: 1, tooltip: "Displays operations shared as common, assign any operation to your self." },
    ...(organizationId
      ? [{ label: "Team Operations", key: 2, tooltip: "Displays operations shared with your team." }]
      : []),
  ];

  // Must match the header cells rendered below (Team View / Actions are tab-dependent)
  const columnCount = 7 + (mainTab === 0 ? 1 : 0) + (mainTab === 0 || mainTab === 1 ? 1 : 0);

  return (
    <Box alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      {/* Main Tabs */}
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        mb={2.5}
        className="gap-4 justify-between"
      >
        <CustomTabs tabs={mainTabs} active={mainTab} onChange={handleMainTabChange} />
        <Button
          color="primary"
          variant="contained"
          className="!capitalize !rounded-none !text-[11px] !font-medium !h-7 !px-3 !bg-[#313C4C] hover:!bg-[#1e2632] !text-white shadow-none"
          onClick={() => {
            setCreateOpsModalMaxWidth("md");
            setOpenCreateOpsModel(true);
          }}
        >
          Create Operation
        </Button>
      </Box>

      <TableContainer component={Paper}>
        {activeDetails?.totalItems > activeFilters?.limit && (
          <CustomPagination
            onChangePagination={onChangePagination}
            filters={activeFilters}
            totalPage={activeFilters?.totalItems}
          />
        )}
        <style>{`
          .ops-table {
            min-width: 0 !important;
            table-layout: fixed !important;
          }
        `}</style>
        <Table className="universal-table ops-table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "40px", minWidth: "40px" }}>No.</TableCell>
              {
                mainTab === 0 && (
                  <TableCell style={{ width: "80px", minWidth: "80px", textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                      Team View
                    </div>
                  </TableCell>
                )
              }
              <TableCell style={{ width: "120px", minWidth: "120px", cursor: "pointer" }} onClick={() => handleSortClick("contractType")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Type
                  <div style={{ color: activeFilters.sortBy === "contractType" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {activeFilters.sortBy === "contractType" && activeFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : activeFilters.sortBy === "contractType" && activeFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell style={{ width: "220px", minWidth: "220px", cursor: "pointer" }} onClick={() => handleSortClick("operationName")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Name
                  <div style={{ color: activeFilters.sortBy === "operationName" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {activeFilters.sortBy === "operationName" && activeFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : activeFilters.sortBy === "operationName" && activeFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell style={{ width: "150px", minWidth: "150px" }}>Vessel Name</TableCell>
              <TableCell style={{ width: "150px", minWidth: "150px" }}>Cargo Name</TableCell>
              <TableCell style={{ width: "90px", minWidth: "90px" }}>Assignee</TableCell>
              <TableCell style={{ width: "90px", minWidth: "90px" }}>AssignedTo</TableCell>
              {
                (mainTab === 0 || mainTab === 1) && (
                  <TableCell style={{ width: "65px", minWidth: "65px", textAlign: "center" }}>Actions</TableCell>
                )
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {activeLoading || loader ? (
              <TableRow>
                <TableCell colSpan={columnCount} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    {activeDetails.length > 0 && <CircularProgress />}
                  </Box>
                </TableCell>
              </TableRow>
            ) : activeDetails.length === 0 && activeHasFetched ? (
              <TableRow>
                <TableCell colSpan={columnCount} align="center" className="!p-0 border-none">
                  <div className="flex flex-col items-center justify-center py-14 px-4 text-center bg-[#f8fafc]">
                    <div className="w-12 h-12 rounded-xl bg-[#f0f6ff] flex items-center justify-center mb-3 shadow-sm border border-blue-100">
                      <FiInbox size={22} className="text-[#313C4C]" />
                    </div>
                    <p className="m-0 text-sm font-medium text-gray-900">
                      {mainTab === 0
                        ? "No operations found"
                        : mainTab === 1
                          ? "No organization operations"
                          : "No team operations found"}
                    </p>
                    <p className="m-0 mt-1 text-[11px] text-gray-500 max-w-md">
                      {mainTab === 0
                        ? "You haven't created or been assigned any operations yet."
                        : mainTab === 1
                          ? "There are currently no public operations recorded for your organization."
                          : "There are currently no operations shared with your team."}
                    </p>
                    <Button
                      color="primary"
                      variant="contained"
                      className="!mt-4 !capitalize !rounded-none !text-[11px] !font-medium !h-7 !px-3 !bg-[#313C4C] hover:!bg-[#1e2632] !text-white shadow-none"
                      onClick={() => {
                        setCreateOpsModalMaxWidth("md");
                        setOpenCreateOpsModel(true);
                      }}
                    >
                      Create Operation
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ) : activeDetails.map((operation, index) => {
              const {
                contractType,
                _id,
                contractName,
              } = operation;
              const actualIndex = activeFilters.limit * (activeFilters.offset - 1) + index + 1;
              const isCargoCargo = contractType === "cargo-cargo";
              const isVesselVessel = contractType === "vessel-vessel";

              // Get vessel and cargo details based on operation type
              const cargo = isVesselVessel
                ? operation?.vesselContractDetails?.vesselDetails?.clientQuery
                : operation?.cargoContractDetails?.cargoDetails;

              const vessel =
                isVesselVessel &&
                  operation?.vesselContractDetails?.vesselDetails?.fleetList
                    ?.length
                  ? operation?.vesselContractDetails?.vesselDetails
                    ?.fleetList?.[0]
                  : operation?.vesselContractDetails?.vesselDetails;

              let parsedPerfVesselName = null;
              if (cargo?.performingVessel) {
                try {
                  if (typeof cargo.performingVessel === "string" && cargo.performingVessel.trim().startsWith("{")) {
                    parsedPerfVesselName = JSON.parse(cargo.performingVessel)?.vesselName;
                  } else if (typeof cargo.performingVessel === "object") {
                    parsedPerfVesselName = cargo.performingVessel?.vesselName;
                  } else {
                    parsedPerfVesselName = cargo.performingVessel;
                  }
                } catch (e) {
                  parsedPerfVesselName = cargo.performingVessel;
                }
              }

              const vesselName = isCargoCargo
                ? parsedPerfVesselName
                : vessel?.vessel
                  ? JSON.parse(vessel.vessel)?.vesselName
                  : null;
              return (
                <TableRow
                  key={operation._id}
                  className="cursor-pointer hover:bg-gray-50"
                  onDoubleClick={() => handleViewOperationCalc(_id, contractType)}
                >
                  <TableCell style={{ width: "40px", minWidth: "40px" }}>{actualIndex}</TableCell>
                  {
                    mainTab === 0 && (
                      <TableCell style={{ width: "80px", minWidth: "80px", textAlign: "center" }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                          <Switch
                            size="small"
                            style={{ margin: "0 auto" }}
                            checked={operation?.isTeamView}
                            onChange={(event) => handleTeamViewChange(operation?._id, event)}
                            name="teamView"
                            color="primary"
                          />
                        </div>
                      </TableCell>
                    )
                  }
                  <TableCell style={{ width: "120px", minWidth: "120px" }}>{operation.contractType}</TableCell>
                  <TableCell style={{ width: "220px", minWidth: "220px" }}>
                    <button
                      onClick={() => { handleViewOperationCalc(_id, contractType) }}
                      className="text-blue underline cursor-pointer"
                    >
                      {operation?.operationName || "-"}
                    </button>
                  </TableCell>
                  <TableCell style={{ width: "150px", minWidth: "150px" }}>{vesselName || "-"}</TableCell>
                  <TableCell style={{ width: "150px", minWidth: "150px" }}>{cargo?.name || "-"}</TableCell>
                  <TableCell style={{ width: "90px", minWidth: "90px" }}>{operation?.assignee?.firstName || "-"}</TableCell>
                  <TableCell style={{ width: "90px", minWidth: "90px" }}>{operation?.assignedTo?.firstName || "-"}</TableCell>
                  {(mainTab === 0 || mainTab === 1) && (
                    <TableCell style={{ width: "65px", minWidth: "65px", textAlign: "center" }}>
                      {operation?.operationAccess === 'public' ?
                        <Tooltip text="Assign to you" position="left">
                          <button
                            onClick={() => { setAssignToYouModelOpen(true); setSelectedOperation(operation?._id) }}
                          >
                            <OpenInNew
                              fontSize='small'
                              style={{ color: "black", cursor: "pointer" }}
                            />
                          </button>
                        </Tooltip> : (
                          <>
                            <Tooltip text="Assign to Other" position="left">
                              <button
                                onClick={() => { setIsShareToOperationModelOpen(true); setSelectedOperation(operation?._id) }}
                              >
                                <OpenInNew
                                  fontSize='small'
                                  style={{ color: "black", cursor: "pointer" }}
                                />
                              </button>
                            </Tooltip>
                          </>
                        )
                      }
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {activeFilters?.totalItems > activeFilters?.limit && (
          <CustomPagination
            onChangePagination={onChangePagination}
            filters={activeFilters}
            totalPage={activeFilters.totalItems}
          />
        )}
      </TableContainer>

      <CustomShowModal
        open={isShareToOperationModelOpen}
        title={"Assign to Other"}
        maxWidth="md"
        saveLabel={"Update"}
        handleClose={() => setIsShareToOperationModelOpen(false)}
      >
        <ShareToOperationModel
          selectedContractId={selectedOperation}
          currentUserId={currentUserId}
          handleClose={() => setIsShareToOperationModelOpen(false)}
          refetch={() => fetchOperations()}
          isOtherTab
        />
      </CustomShowModal>

      <CustomAddModal
        open={assignToYouModelOpen}
        maxWidth="md"
        saveLabel="Assign to Me"
        handleClose={() => setAssignToYouModelOpen(false)}
        onSubmitConfirm={onConfirmAssignToYou}
      >
        {/* Content */}
        <div className="px-6 py-8 text-center">
          <div className="mx-auto flex items-center justify-center rounded-full bg-blue-100 mb-6">
            <InfoTwoTone className="h-16 w-16" color="primary" />
          </div>

          <h3 className="text-xl font-medium text-gray-900 mb-2">
            Are you sure you want to assign this operation to yourself?
          </h3>

          <div className="bg-rose-50 border border-rose-200 rounded-md p-4 mb-4">
            <p className="text-darkRed text-sm">
              Note: You are about to take ownership of the selected operation
            </p>
          </div>
        </div>
      </CustomAddModal>

      <CustomShowModal
        open={openCreateOpsModel}
        maxWidth={createOpsModalMaxWidth}
        title="Create Operation"
        handleClose={() => setOpenCreateOpsModel(false)}
        showCloseButton={false}
        contentClassName="!p-1.5 sm:!p-1.5 !overflow-x-hidden"
      >
        <CreateOperation
          setLoader={setLoader}
          loader={loader}
          refetch={fetchOperations}
          onClose={() => setOpenCreateOpsModel(false)}
          setMaxWidth={setCreateOpsModalMaxWidth}
        />
      </CustomShowModal>
    </Box>
  );
};

export default Operations;